import { render, staticRenderFns } from "./wyPoint.vue?vue&type=template&id=add4c5c4"
import script from "./wyPoint.vue?vue&type=script&lang=js"
export * from "./wyPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports